import { PerformanceRating } from 'nomst/Stores/Configuration/performanceRating';
import { GeneralConfiguration } from 'nomst/Stores/Configuration/generalConfiguration';
import { EmployeeFormatConfiguration } from 'nomst/Stores/Configuration/employeeFormatConfiguration';
import { CustomFieldMetadata } from 'typings/customFieldMetaData';
import { IConfiguration } from 'typings/configuration';

export class SettingsConfiguration {
    performanceRatings: PerformanceRating[];
    formatConfiguration: EmployeeFormatConfiguration;
    generalConfiguration: GeneralConfiguration;
    currencies: ICurrency[];
    homeCountryCurrency: string;
    hasMultipleCurrency: boolean;
    customFieldMetadata: CustomFieldMetadata[];

    _perfMap: Map<string, PerformanceRating>;

    constructor(dto: IConfiguration) {
        this.performanceRatings = [];
        dto.performanceRatings?.forEach(rating => {
            this.performanceRatings.push(new PerformanceRating(rating.id, rating.name));
        });
        this.formatConfiguration = new EmployeeFormatConfiguration(dto.formatConfiguration._employeeNameSortFormat);
        this.generalConfiguration = new GeneralConfiguration(dto.generalConfiguration);
        this.currencies = dto.currencies;
        this.homeCountryCurrency = dto.homeCountryCurrency;
        this.hasMultipleCurrency = dto.hasMultipleCurrency;
        this.customFieldMetadata = dto.customFieldMetadata ?? [];
    }

    getPerformanceRatingText(name: string): string {
        if (this._perfMap == null) {
            this._perfMap = new Map<string, PerformanceRating>(this.performanceRatings.map(
                (rating: PerformanceRating): [string, PerformanceRating] => [rating.name, rating]));
        }
        const performanceRating = this._perfMap.get(name);
        return performanceRating ? performanceRating.name : '';
    }
}